export default __webpack_public_path__ + "static/mexico-055ef6c4f57e6f31af265985293858dd.svg";